import React, { Component } from 'react';
import * as GServ from '../services/GatewayService';
import { CircularProgress } from '@material-ui/core';

export default class TokenHandler extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSpinner: true,
            status: 'Verifying...',
            warning: '',
        }
    }

    componentDidMount = () => {
        GServ.turn_key(this.props.token)
        .then(reply => {
            // console.log('Reply from turn_key attempt => ',reply);
            if (reply.Result !== "Success"){
                this.setState({showSpinner:false,status:'',warning:'Invalid Link: ' + reply.Message})
            } else {
                //unlock by token was successfull...
                // Need to also send up email and a bunch of other details...
                this.props.setParentState({
                    unlocked_by_token_key:true,
                    application_for: reply.Props.application_for,
                    email: reply.Props.contact_email,
                    fname: reply.Props.fname,
                    lname: reply.Props.lname,
                    mobile: reply.Props.mobile,
                    form_min_age: reply.Props.Form_Min_Age,
                    form_max_age: reply.Props.Form_Max_Age,
                    form_url: reply.Props.Form_Url,
                    form_title: reply.Props.Form_Title,
                    form_token: reply.Props.Form_Token,
                    user_status: reply.UserStatus,
                    showPrime: false, //start here...
                    showIDNum: !reply.Props.has_id,
                    showCheckAppStatus: reply.Props.has_id,
                    id_on_file: reply.Props.has_id,
                    may_reapply_on_form: reply.Props.may_reapply_on_form,
                    institution_name: reply.Props.institution_name,
                    contact_phone: reply.Props.contact_phone,
                    domain: reply.Props.domain,
                    info_email: reply.Props.info_email,
                    gwt: reply.GWT
                });
            }
        })
        .catch(e => {
            console.log('Error on return from GServ.turn_key => ',e);
            this.setState({showSpinner:false,status:'',warning:'Technical error encountered - we were unable to verify your email address. If this problem persists, please contact us.'})
        });
    };
    
    
    render() {
        return (
            <div>
                <br/>
                <hr/>
                <span id="StatusBar" className="StatusBar">
                    {this.state.showSpinner&&<CircularProgress size={30} />}&nbsp;&nbsp;
                    {this.state.status}
                </span>
                <span className='warningMessage'>{this.state.warning}</span>
            </div>
        );

    }
    
}
